module.exports = __webpack_public_path__ + "img/customer_2_en.11830e49.png";